<template>
  <div>
    <b-form-select
      v-model="selected"
      :options="options"
      class="mb-3"
    />
    <PDF
      v-if="selected !== null"
      :src="`/pdf/${selected}.pdf`"
    />
  </div>
</template>

<script>
import PDF from 'vue-pdf/src/vuePdfNoSss.vue';

export default {
  components: {
    PDF,
  },

  data() {
    return {
      selected: null,
      options: [
        { value: null, text: 'Please select one' }, //
        { value: 'daily-habits', text: 'Daily Habits' },
        { value: 'weekly-habits', text: 'Weekly Habits' },
        { value: 'monthly-habits', text: 'Monthly Habits' },
        { value: 'meal-plan', text: 'Meal Plan' },
      ],
    };
  },
};
</script>
